//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import wx from 'weixin-js-sdk'; 

export default {
  components: {
      cmBlank
  },
  data () {
    return {
      blankShow:false,
      loadStatus:false,
      loadmoreText:'正在加载。。。',
      busy:false,
      code:'',
    //   strip_code:'',
    //   phone:'',
      pageFlag:2,
      hasNext:0,
      lastId:0,
      list:[],
      checkAllStatus:false,
      allText:'全选',
      ids:'',
    }
  },
  created(){
    this.config();
    this.search();
  },
  amount(){
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    search(){
        this.list = [];
        this.getList();
    },
    reset(){
        this.code = '';
        this.list = [];
        this.getList();
    },
    check(i){
        if(this.list[i].checked > 0){
            this.list[i].checked = 0;
        }else{
            this.list[i].checked = 1;
        }
    },
    checkAll(){
        this.checkAllStatus = !this.checkAllStatus;
        if(this.checkAllStatus){
            this.list.forEach((item,index)=>{
                item.checked = 1;
            })
            this.allText = '全不选';
        }else{
            this.list.forEach((item,index)=>{
                item.checked = 0;
            })
            this.allText = '全选';
        }
    },
    getList(){
        if(!this.code){
            this.$func.showToast('请输入手机号|衣物编码|灯条编码查询');
            return ;
        }
        this.$api.waitPick({code:this.code}).then((res)=>{
            if(res){
                if(!this.lastId){
                    this.blankShow = res.data.length > 0 ? false : true;
                }
                this.hasNext = res.hasNext;
                this.lastId = res.lastId;
                res.data.forEach((item)=>{
                    this.list.push(item);
                });
            }
        }) 
    },

    pick () {
        this.ids = '';
        this.list.forEach((item,index) => {
            if(item.checked){
                this.ids += item.id+',';
            }
        });
        this.$func.confirm('确认已取衣？','提示',()=>{
            this.$func.startLoading();
            this.$api.pickClothe({ids:this.ids}).then((res)=>{
                if(res){
                    this.$func.endLoading();
                    this.$func.showToast('操作成功');
                    setTimeout(()=>{
                        this.reset();
                    },300)
                   
                } 
            }) 
        }) 
    },
    barOrder(code){
        this.$router.push({name:'barOrder',params:{code:code}})
    },
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ["barCode"],
            success: function (res) {
                setTimeout(()=>{
                    that.code = that.$func.parseScanResult(res.resultStr);
                    that.search();
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/pickClothe.vue